const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<ul class="demo-favicon-apps">
  `);
                if (this.compare((context.has(`platform`) ? context.get(`platform`) : null), `apple`)) {
                    this.echo(`    <li class="demo-favicon-app">
      <svg viewBox="0 0 180 180" width="44" height="44">
        <image href="/favicons/apple-touch-icon.png"/>
      </svg>
      <span>Cloud Four</span>
    </li>
  `);
                }
                else {
                    this.echo(`    <li class="demo-favicon-app">
      <svg viewBox="0 0 192 192" width="48" height="48">
        <image href="/favicons/icon-192.png"/>
      </svg>
      <span>Cloud Four</span>
    </li>
    <li class="demo-favicon-app demo-favicon-app--circle">
      <svg viewBox="0 0 192 192" width="48" height="48">
        <image href="/favicons/icon-192.png"/>
      </svg>
      <span>Cloud Four</span>
    </li>
  `);
                }
                this.echo(`</ul>
`);
            }

            getTemplateName() {
                return `d43e287d053c1c85b5324f1fbe50ab3c702025d39b6b196440e4666b4f37072b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d43e287d053c1c85b5324f1fbe50ab3c702025d39b6b196440e4666b4f37072b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'd43e287d053c1c85b5324f1fbe50ab3c702025d39b6b196440e4666b4f37072b');

let template = env.loadTemplate('d43e287d053c1c85b5324f1fbe50ab3c702025d39b6b196440e4666b4f37072b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/design/demo/favicon-apps.twig", args: context }
     );
     return rendered;;
};